import { ReactNode } from 'react'
import { Canvas as ThreejsCanvas, CanvasProps } from '@react-three/fiber'

import CanvasErrorBoundary from './CanvasErrorBoundary'

const Canvas = ({
  children,
  canvasProps = {},
  fallback = null,
}: {
  children: JSX.Element | JSX.Element[]
  canvasProps?: CanvasProps
  fallback?: ReactNode
}) => {
  return (
    <CanvasErrorBoundary fallback={fallback}>
      <ThreejsCanvas
        dpr={2}
        gl={{
          antialias: true,
          preserveDrawingBuffer: true,
          powerPreference: 'high-performance',
        }}
        {...canvasProps}
      >
        {children}
      </ThreejsCanvas>
    </CanvasErrorBoundary>
  )
}

export default Canvas
